module.exports = "https://web-assets.ifttt.com/packs/media/icons/sunny-42dc3096.png";